export default "__VITE_ASSET__BmH3ogdf__"